import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postPartners, type SavePartnerRequest } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "../Queries/queryKeys";

export function useCreatePartnerMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SavePartnerRequest) =>
      postPartners(request),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.all,
      });
    },
  });
}
